function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import { PixiComponent } from '@inlet/react-pixi';
import * as PIXI from 'pixi.js';
import * as R from 'unitx/ramda';
import * as V from 'unitx/vector';
import { THEME } from "../../utils/constants";
const controlPointsCreator = {
  bezier: config => {
    const {
      from,
      to,
      distance,
      count,
      unit
    } = config;
    const upperNormVector = V.rotate(-Math.PI / 2)(unit);
    const upperVector = V.multiplyScalar(distance)(upperNormVector);
    const lowerVector = V.multiplyScalar(-1)(upperVector);
    const chunkDistanceVector = R.pipe(V.subtract(from), V.divideScalar(count))(to);
    const semiChunkDistanceVector = V.divideScalar(2)(chunkDistanceVector);
    return R.mapIndexed((_, index) => {
      const isUpper = index % 2;
      const startVec = R.pipe(V.multiplyScalar(index), V.add(from))(chunkDistanceVector);
      const midVec = R.pipe(V.add(semiChunkDistanceVector), V.add(isUpper ? upperVector : lowerVector))(startVec);
      const endVec = V.add(startVec)(chunkDistanceVector);
      return [startVec, midVec, endVec];
    })(R.range(0, count));
  }
};

const drawArrowHead = ({
  graphics: mutableGraphics,
  to,
  radius = 10,
  unit,
  fill
}) => {
  const bottomCenter = to;
  const unitDistanceVec = V.multiplyScalar(radius)(unit);
  const perpendicularUnitDistanceVec = V.rotate(-Math.PI / 2)(unitDistanceVec);
  const leftControlPoint = R.pipe(V.multiplyScalar(-1), V.add(bottomCenter))(perpendicularUnitDistanceVec);
  const rightControlPoint = R.pipe(V.add(bottomCenter))(perpendicularUnitDistanceVec);
  const topControlPoint = V.add(unitDistanceVec)(to);
  mutableGraphics.beginFill(fill);
  mutableGraphics.drawPolygon(new PIXI.Point(leftControlPoint.x, leftControlPoint.y), new PIXI.Point(rightControlPoint.x, rightControlPoint.y), new PIXI.Point(topControlPoint.x, topControlPoint.y));
  mutableGraphics.endFill();
};

export const drawLine = config => {
  const {
    from: fromBoundingBox,
    to: toBoundingBox,
    fill = THEME.fillColor,
    directed,
    type,
    //= 'bezier',
    graphics: mutableInstance,
    width = 4,
    alpha = 1,
    arrowHead = {
      radius: 2
    }
  } = config;
  const fromPos = {
    x: fromBoundingBox.x,
    y: fromBoundingBox.y
  };
  const toPos = {
    x: toBoundingBox.x,
    y: toBoundingBox.y
  };
  const {
    to,
    from,
    distanceVector
  } = R.ifElse(R.isTrue, () => {
    const centerOfFrom = V.add(fromBoundingBox.width / 2, fromBoundingBox.height / 2)(fromPos);
    const centerOfTo = V.add(toBoundingBox.width / 2, toBoundingBox.height / 2)(toPos);
    const radiusFrom = Math.hypot(fromBoundingBox.width, fromBoundingBox.height) / 2;
    const radiusTo = Math.hypot(toBoundingBox.width, toBoundingBox.height) / 2;
    const distanceVector = R.pipe(V.subtract(centerOfFrom))(centerOfTo);
    const radiusDistanceVectorFrom = R.pipe(V.subtract(centerOfFrom), V.normalize, V.multiplyScalar(radiusFrom))(centerOfTo);
    const radiusDistanceVectorTo = R.pipe(V.subtract(centerOfTo), V.normalize, V.multiplyScalar(radiusTo))(centerOfFrom);
    return {
      from: R.pipe(V.add(radiusDistanceVectorFrom))(centerOfFrom),
      to: R.pipe(V.add(radiusDistanceVectorTo))(centerOfTo),
      // radiusFrom,
      // radiusTo,
      distanceVector
    };
  }, R.always({
    to: toPos,
    from: fromPos,
    // radiusTo: 50,
    // radiusFrom: 50,
    distanceVector: R.pipe(V.subtract(fromPos))(toPos)
  }))(directed); // const midpoint = R.pipe(
  //   V.divideScalar(2),
  //   V.add(from),
  // )(distanceVector)

  const unit = V.normalize(distanceVector);
  mutableInstance.clear();
  mutableInstance.lineStyle(width, fill, alpha);
  drawArrowHead(_objectSpread({
    graphics: mutableInstance,
    unit,
    to,
    fill
  }, arrowHead));
  R.cond([[R.equals('bezier'), () => {
    const controlPoints = controlPointsCreator.bezier({
      from,
      to,
      count: 2,
      distance: 100,
      unit
    });
    R.map(([start, mid, end]) => {
      mutableInstance.moveTo(start.x, start.y);
      mutableInstance.bezierCurveTo(start.x, start.y, mid.x, mid.y, end.x, end.y);
    })(controlPoints);
  }], [R.equals('segments'), () => {
    const controlPoints = controlPointsCreator.bezier({
      from,
      to,
      count: 4,
      distance: 100,
      unit
    });
    R.map(([start, mid, end]) => {
      mutableInstance.moveTo(start.x, start.y);
      mutableInstance.lineTo(mid.x, mid.y);
      mutableInstance.moveTo(mid.x, mid.y);
      mutableInstance.lineTo(end.x, end.y);
    })(controlPoints);
  }], [R.T, () => {
    mutableInstance.moveTo(from.x, from.y);
    mutableInstance.lineTo(to.x, to.y);
  }]])(type);
  mutableInstance.endFill();
  mutableInstance.zIndex = -100;
};
const Graphics = PixiComponent('PIXIGraphics', {
  create: () => {
    const mutableInstance = new PIXI.Graphics();
    return mutableInstance;
  },
  applyProps: (mutableInstance, __, _props) => {}
});
export default Graphics;